import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import {
  getAllOrganisations,
  organisationSelector,
  updateOrganisationStatus,
} from "src/store/slices/organisationSlice";
import { userSelector } from "src/store/slices/userSlice";
import StatusDataGrid, { statusColumn } from "src/components/StatusDataGrid";
import {
  organisationStatusChanges,
  organisationStatusColors,
  organisationStatusLabels,
  userTypes,
} from "src/constants";

const columns = [
  {
    field: "dateAdded",
    headerName: "Date added",
    type: "string",
    width: 130,
  },
  {
    field: "id",
    headerName: "ID",
    type: "string",
    width: 240,
  },
  {
    field: "name",
    headerName: "Name",
    width: 280,
  },
  {
    field: "abn",
    headerName: "ABN",
    width: 150,
  },
  {
    field: "acn",
    headerName: "ACN",
    width: 150,
  },
  {
    field: "entityType",
    headerName: "Entity Type",
    width: 240,
  },
  statusColumn({
    field: "status",
    headerName: "Status",
    labels: organisationStatusLabels,
    colors: organisationStatusColors,
    width: 190,
  }),
];

// What master users change from an organisation's status dropdown
const masterStatusChanges = { status: organisationStatusChanges };

export default function OrganisationList() {
  const dispatch = useDispatch();
  const { gettingOrganisations, organisations } =
    useSelector(organisationSelector);
  const { userType } = useSelector(userSelector);
  const isMaster = userType === userTypes.MASTER;

  const [rows, setRows] = useState([]);

  useEffect(() => {
    dispatch(getAllOrganisations({}));
  }, []);

  useEffect(() => {
    if (organisations?.length > 0) {
      const orgRows = organisations?.map((doc) => {
        const date = new Date(doc.createdAt);

        return {
          id: doc._id,
          name: doc.name,
          abn: doc.abn || "-",
          acn: doc.acn || "-",
          entityType: doc?.entityType || "-",
          status: doc?.status,
          dateAdded: `${date.getDate()}.${
            date.getMonth() + 1
          }.${date.getFullYear()}`,
        };
      });
      setRows(orgRows);
    } else {
      setRows([]);
    }
  }, [organisations]);

  const changeStatus = (row, field, status) =>
    dispatch(updateOrganisationStatus({ organisationId: row.id, status })).unwrap();

  return (
    <Grid
      container
      item
      direction="column"
      spacing={2}
      style={{ marginTop: "64px", padding: "20px" }}
    >
      <Grid item>
        <Typography
          variant="h1"
          style={{ fontSize: "32px", fontWeight: 800, letterSpacing: "-1.5px" }}
        >
          Organisations
        </Typography>
      </Grid>
      <Grid item style={{ height: "66vh" }}>
        <StatusDataGrid
          loading={gettingOrganisations}
          onCellClick={(params, event) => {
            event.defaultMuiPrevented = true;
          }}
          rows={rows || []}
          columns={columns}
          statusChanges={isMaster ? masterStatusChanges : undefined}
          onStatusChange={changeStatus}
          pageSize={10}
          rowsPerPageOptions={[10]}
          disableSelectionOnClick
          style={{ background: "#ffffff" }}
        />
      </Grid>
    </Grid>
  );
}
